import React, { useState, useEffect } from "react";
import { COUPLE_IMAGE, API } from "../constants";
import "./NameModal.css";

export default function NameModal({ onSave }) {
  const [name, setName] = useState("");
  const [existingNames, setExistingNames] = useState([]);
  const [warned, setWarned] = useState(false);

  // Load existing uploader names on mount
  useEffect(() => {
    fetch(`${API}/api/gallery/uploaders`)
      .then((r) => r.json())
      .then((names) => setExistingNames(names.map((n) => n.toLowerCase())))
      .catch(() => {});
  }, []);

  const isDuplicate = name.trim().length > 0 &&
    existingNames.includes(name.trim().toLowerCase());

  const submit = () => {
    if (!name.trim()) return;
    // If duplicate and not yet warned, show warning first
    if (isDuplicate && !warned) {
      setWarned(true);
      return;
    }
    onSave(name.trim());
  };

  const handleChange = (e) => {
    setName(e.target.value);
    setWarned(false);
  };

  return (
    <div className="welcome">
      {/* Background photo */}
      <img src={COUPLE_IMAGE} alt="" className="welcome__bg" />
      <div className="welcome__overlay" />

      {/* Content */}
      <div className="welcome__content">
        <p className="welcome__eyebrow">30 · 05 · 2026</p>
        <h1 className="welcome__title">Witaj na weselu!</h1>
        <p className="welcome__sub">Jak masz na imię?</p>

        <input
          className="welcome__input"
          placeholder="Twoje imię..."
          value={name}
          onChange={handleChange}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          autoFocus
        />

        {warned && isDuplicate && (
          <p className="welcome__warn">
            Ktoś o imieniu <strong>{name.trim()}</strong> już dołączył. Czy to Ty?
            Naciśnij ponownie, aby kontynuować.
          </p>
        )}

        <button
          className={`welcome__btn ${!name.trim() ? "welcome__btn--disabled" : ""}`}
          onClick={submit}
        >
          Wejdź na wesele ✨
        </button>
      </div>
    </div>
  );
}
